import type {z} from "zod";

import {UpdateClientBody} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {clientFieldLabelIds} from "../../../messages/clients.messages";

const updateCompany = UpdateClientBody.shape.company;
const updateProfile = updateCompany.shape.partyProfile;
const updatePhone = updateProfile.shape.phone;

export const updateClientAddressSchema = requiredStringSchema(
  updateProfile.shape.address.shape.address,
  clientFieldLabelIds.address,
);
export const updateClientCompanyNameSchema = requiredStringSchema(
  updateCompany.shape.companyName,
  clientFieldLabelIds.companyName,
);
export const updateClientCompanyIdSchema = requiredStringSchema(
  updateCompany.shape.companyId,
  clientFieldLabelIds.companyId,
);

export const updateClientFormSchema = zod.object({
  companyId: updateClientCompanyIdSchema,
  companyName: updateClientCompanyNameSchema,
  address: updateClientAddressSchema,
  country: updateProfile.shape.country,
  phoneNumber: updatePhone.shape.nationalNumber,
  phonePrefix: updatePhone.shape.regionCode,
  websiteUrl: updateProfile.shape.websiteUrl,
  logoUrl: UpdateClientBody.shape.logoUrl,
  type: UpdateClientBody.shape.environments,
});
export type UpdateClientFormPayload = z.output<typeof updateClientFormSchema>;

export const draftUpdateClientFormSchema = updateClientFormSchema.partial();
export type DraftUpdateClientFormPayload = z.output<typeof draftUpdateClientFormSchema>;
